module.exports = __webpack_public_path__ + "img/max-person-repeat.f867790c.svg";